import {
    MessagesService
} from '@/common/api.service.js'

export class Message {
    constructor ({
        broadcast = null,
        children = [],
        content = null,
        created_at = null,
        created_from = null,
        created_to = null,
        creator = null,
        id = null,
        parent = null,
        receiver = null,
        ref = null,
        status = 0,
        title = null,
        type = null,
        updated_at = null
    } = {}) {
        this.broadcast = broadcast
        this.children = children
        this.content = content
        this.created_at = created_at
        this.created_from = created_from
        this.created_to = created_to
        this.creator = creator
        this.id = id
        this.parent = parent
        this.receiver = receiver
        this.ref = ref
        this.status = status
        this.title = title
        this.type = type
        this.updated_at = updated_at
    }
}

export function responseAdapter (response) {
    return new Message({
        ...response
    })
}

export function requestAdapter (request) {
    return request
}

export default {
    getSingle: id => new Promise((resolve, reject) => {
        MessagesService.get(id)
            .then(({
                data
            }) => {
                resolve({
                    data: responseAdapter(data),
                    id: id
                })
            }).catch(e => {
                reject(e)
            })
    }),
    getList: params => new Promise((resolve, reject) => {
        MessagesService.query(params)
            .then(({
                data,
                headers
            }) => {
                resolve({
                    data: data.map(x => responseAdapter(x)),
                    headers
                })
            }).catch(e => {
                reject(e)
            })
    }),
    create: message => new Promise((resolve, reject) => {
        MessagesService.create(requestAdapter(message))
            .then((
                data
            ) => {
                resolve(data)
            }).catch(e => {
                reject(e)
            })
    }),
    update: message => new Promise((resolve, reject) => {
        MessagesService.update(message)
            .then((
                data
            ) => {
                resolve(data)
            })
            .catch(e => {
                reject(e)
            })
    }),
    delete: id => new Promise((resolve, reject) => {
        MessagesService.delete(id)
            .then((
                data
            ) => {
                resolve(data)
            })
            .catch(e => {
                reject(e)
            })
    })
}
